module.exports = __webpack_public_path__ + "media/images/own_icon_active-97a70084.svg";